var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWegawWhiteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 246.19 87.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M43.51,53a9.37,9.37,0,1,1,9.37-9.37A9.38,9.38,0,0,1,43.51,53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,43.77A43.51,43.51,0,0,0,43.51,87.28V72.41A28.64,28.64,0,0,1,14.87,43.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M87,43.51A43.51,43.51,0,0,0,43.51,0V14.87A28.65,28.65,0,0,1,72.16,43.51Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "137.85 53.14 133.93 39.52 133.82 39.52 129.93 53.14 126.23 53.14 121.48 34.8 124.52 34.8 128.23 49.3 128.36 49.3 132.38 34.8 135.53 34.8 139.63 49.3 139.76 49.3 143.28 34.8 146.29 34.8 141.52 53.14 137.85 53.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "154.87 53.14 154.87 34.8 167.1 34.8 167.1 37.52 157.88 37.52 157.88 42.53 165.85 42.53 165.85 45.25 157.88 45.25 157.88 50.42 167.1 50.42 167.1 53.14 154.87 53.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M183.2,45.54V42.93h6.5v9.83c-.92.18-1.94.32-3.06.43s-2.1.16-2.93.16a12.57,12.57,0,0,1-5-.77,4.31,4.31,0,0,1-2.28-2.73,20.55,20.55,0,0,1-.63-5.88,20.48,20.48,0,0,1,.64-5.88,4.37,4.37,0,0,1,2.3-2.73,12.47,12.47,0,0,1,5-.77c.88,0,1.88,0,3,.16a26.81,26.81,0,0,1,2.91.43v2.53a37.29,37.29,0,0,0-4.61-.4,17.89,17.89,0,0,0-4.18.32,2.29,2.29,0,0,0-1.59,1.65,16.73,16.73,0,0,0-.44,4.69,20.9,20.9,0,0,0,.33,4.44,2.55,2.55,0,0,0,1.34,1.82,8.42,8.42,0,0,0,3.34.48,20.84,20.84,0,0,0,3-.16v-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M206.33,37.84h-.13L203.26,46h6Zm5.44,15.3-1.63-4.43h-7.75l-1.58,4.43h-3l6.58-18.34h3.91l6.59,18.34Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "237.75 53.14 233.83 39.52 233.72 39.52 229.83 53.14 226.13 53.14 221.38 34.8 224.42 34.8 228.13 49.3 228.26 49.3 232.28 34.8 235.43 34.8 239.53 49.3 239.66 49.3 243.18 34.8 246.19 34.8 241.42 53.14 237.75 53.14"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWegawWhiteIcon);
export default __webpack_public_path__ + "static/media/wegaw-white-icon.3742afb73a2276c63754a5a99693a5bf.svg";
export { ForwardRef as ReactComponent };